import axios from "axios";

const api = axios.create({
  baseURL: "https://hrbackend-35he.onrender.com/api/",
});

export default api;
